/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Text from "../ui/Text";
import AddToCalendarModal from "./AddToCalendarModal";
import ButtonGroup from "../ui/ButtonGroup";
import Button from "../ui/Button";
import Icon from "../ui/Icon";
import FormatDateTime from "../formatters/FormatDateTime";
import FormatDatePeriod from "../formatters/FormatDatePeriod";

const StyledBookingSuccessRecurringSessions = styled.div`
  display: grid;
  gap: 8px;
  place-items: center;
`;

const BookingSuccessRecurringSessionsList = styled.div`
  display: grid;
  gap: 0.5rem;
  min-width: 360px;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
`;

const BookingSuccessRecurringSessionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 1.5rem;
`;

const BookingSuccessRecurringSessions = ({ sessions, bookingEntities }) => {
  return (
    <StyledBookingSuccessRecurringSessions>
      <Text color="dark">Your next appointments</Text>
      <BookingSuccessRecurringSessionsList>
        {sessions.map((session) => {
          return (
            <BookingSuccessRecurringSessionItem key={session.id}>
              <Text color="dark">
                <FormatDateTime value={session.start_datetime} format={FormatDateTime.FORMAT.DATE} />
                {", "}
                <FormatDatePeriod
                  from={session.start_datetime}
                  to={session.end_datetime}
                  format={FormatDatePeriod.FORMAT.TIME}
                />
              </Text>
              <ButtonGroup>
                {session.online_meeting_link && (
                  <Button variant="outline" size="icon" icon={<Icon.VideoIcon />} href={session.online_meeting_link} target="_blank" />
                )}
                <AddToCalendarModal
                  bookings={[session]}
                  bookingEntities={bookingEntities}
                  onlineMeetingLink={session.online_meeting_link}
                  trigger={<Button variant="outline" size="icon" icon={<Icon.CalendarPlus />} />}
                />
              </ButtonGroup>
            </BookingSuccessRecurringSessionItem>
          );
        })}
      </BookingSuccessRecurringSessionsList>
    </StyledBookingSuccessRecurringSessions>
  );
};

export default BookingSuccessRecurringSessions;
